/// <reference types="@types/gtag.js" />.

import Script from "next/script";


export function updateGoogleConsent(consentGranted: boolean) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  const status = consentGranted ? "granted" : "denied";

  gtag("consent", "update", {
    "analytics_storage": status,
    "functionality_storage": status,
    "personalization_storage": status,
    "ad_storage": status,
    "ad_user_data": status,
    "ad_personalization": status,
  });
}


export function GoogleGtmHead() {
  const tagId = process.env.NEXT_PUBLIC_GOOGLE_GTM;

  if (!tagId) {
    return null;
  }

  return (
    <Script
      id="gtm-init"
      // strategy="afterInteractive"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){ dataLayer.push(arguments); }
          gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            functionality_storage: 'denied',
            personalization_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
          });
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${tagId}');
        `
      }}
    />
  );
}


export function GoogleGtmBody() {
  const tagId = process.env.NEXT_PUBLIC_GOOGLE_GTM;

  if (!tagId) {
    return null;
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${tagId}`}
        height="0"
        width="0"
        style={{
          display: "none",
          visibility: "hidden",
        }}
      />
    </noscript>
  );
}
